import React, { useState, useEffect, useCallback } from "react";
import Slider from "react-slick";
import { SliderWrapper } from "shared/Slider/styled";
import { Card } from "styles/MainCards.styled";
import TemplateForRecipes from "./fragment/templateForRecipes";
import TemplateForCreators from "./fragment/templateForCreators";
import TemplateForSpotlight from "./fragment/templateForSpotlight";
import MacOsStub from "./fragment/MacOsStub";

const SliderTemplate = ({
  list = [],
  type,
  context,
  setSaved,
  size = "small",
  settingsSlider,
  isCreatorData,
  addStubToEnd,
}) => {
  const [isDetectMouseAction, setDetectMouseAction] = useState(false);
  const [isMouseMove, setMouseMove] = useState(false);
  const [mousePosition, setMousePosition] = useState(0);

  const handleMouseMove = useCallback((e) => {
    if (isDetectMouseAction) {
      let point = e.pageX - mousePosition;
      if (point >= 80 || point <= -80) setMouseMove(true);
    }
  }, []);

  const setSavedClick = useCallback((id, index) => setSaved(id, index), []);

  const handleClick = useCallback((e) => {
    if (isMouseMove) e.preventDefault();
  }, []);

  const handleMouseUp = useCallback(() => {
    setDetectMouseAction(false);
  }, []);

  const handleMouseDown = useCallback((e) => {
    setMouseMove(false);
    setMousePosition(e.pageX);
    setDetectMouseAction(true);
  }, []);

  useEffect(() => {
    window.addEventListener("mouseup", handleMouseUp);
    return () => {
      window.removeEventListener("mouseup", handleMouseUp);
    };
  }, []);

  return (
    <SliderWrapper className={size}>
      <Slider {...settingsSlider}>
        {list.map((item) => {
          return (
            <Card key={item.id}>
              {(type === "recipes" || type === "collections") && (
                <TemplateForRecipes
                  handleMouseMove={handleMouseMove}
                  handleMouseDown={handleMouseDown}
                  handleClick={handleClick}
                  type={type}
                  isCreatorData={isCreatorData}
                  context={context}
                  setSaved={setSavedClick}
                  item={item}
                />
              )}
              {type === "users" && <TemplateForCreators item={item} context={context} />}
              {type === "spotlight" && <TemplateForSpotlight item={item} context={"users"} />}
            </Card>
          );
        })}
        {addStubToEnd && <MacOsStub />}
      </Slider>
    </SliderWrapper>
  );
};

export default SliderTemplate;
